import { StyledCheckoutBox } from './style';
import { CheckoutBoxProps } from './types';

const CheckoutBox = ({
    height = '135px',
    width = '90%',
    children
}: CheckoutBoxProps) => {
    return (
        <StyledCheckoutBox height={height} width={width}>
            {children}
        </StyledCheckoutBox>
    );
};

export default CheckoutBox;
